import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import Skeleton from "../home/Skeleton";

function Sentecias() {
  const [post, setPost] = useState([]);
  const [recuperado, setRecuperado] = useState(false);
 
  function mostrarTabla() {
    return (
      <section className="news_section layout_padding">
        <div className="container">
          <div className="d-flex flex-column align-items-end">
            <div className="custom_heading-container">
              <hr />
              <h2>Sentecias</h2>
            </div>

          </div>
          <div className="row">
            {post.registros.map((publicaciones) => {

              return (
                <div className="col-md-4">
                  <div className="box">
                    <div className="img-box">
                      <img src={publicaciones.thumb} alt="" />
                    </div>
                    <div className="action-box">
                      <div className="action">
                        <Link to="blog/:id">
                          <img src="images/like.png" alt="" />
                        </Link>
                        <Link to="blog/:id">
                          <img src="images/comment.png" alt="" />
                        </Link>
                        <Link to="blog/:id">
                          <img src="images/share.png" alt="" />
                        </Link>
                      </div>
                    </div>
                    <div className="detail-box">
                      <h4>{publicaciones.titulo}</h4>
                      <p>{publicaciones.extracto}</p>
                      <div>
                        <Link to={`/normatividad/sentencias/${publicaciones.id}`} className="btn btn-secondary">Leer mas...</Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    );
  }

  useEffect(() => {
    fetch("https://service.aspuchoco.org/sentencias.php")
      .then((response) => {
        return response.json();
      })
      .then((post) => {
        setPost(post);
        setRecuperado(true);
      });
  }, []);

  if (recuperado) return mostrarTabla();
  else
    return (
      <section className="news_section layout_padding">
        <div className="container">
          <div className="d-flex flex-column align-items-end">
            <div className="custom_heading-container">
              <hr />
              <h2>Sentecias</h2>
            </div>
            <p>
              --------------------------------------------------------------------
            </p>
          </div>
          <div className="row">
            <Fragment>
              <div className="col-md-4">
                <div className="box">
                  <Skeleton />
                </div>
              </div>
              <div className="col-md-4">
                <div className="box">
                  <Skeleton />
                </div>
              </div>
              <div className="col-md-4">
                <div className="box">
                  <Skeleton />
                </div>
              </div>
            </Fragment>
          </div>
        </div>
      </section>
    );
}

export default Sentecias;

